export default "__VITE_ASSET__3ec9bb89__"